import React from 'reactn';
import TextField from '@material-ui/core/TextField';

interface SelectTextProps {
	value: string;
	label: string;
	id: string;
	autoFocus: boolean;
	onChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

const SelectText: React.FC<SelectTextProps> = ({ id, label, value, onChange, autoFocus }) => (
	<TextField
		margin="normal"
		color="secondary"
		autoComplete="off"
		autoCorrect="off"
		autoCapitalize="off"
		spellCheck="true"
		id={id}
		label={label}
		value={value}
		onChange={onChange}
		autoFocus={autoFocus}
		fullWidth
	/>
);

export default SelectText;
